
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class OrtBakiyeListEbelediyeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "YapilandirmaIslemleri/OrtBakiyeListEbelediye";
        super(baseUrl);
    }


    ortBakiyeListEbelediye(request: OrtBakiyeListEbelediyeRequest) {

        return this.post("", request);

    }

}
export default new OrtBakiyeListEbelediyeAPI();

class OrtBakiyeListEbelediyeRequest {
    yapilandirmaTuru?: string;
    sicilKodu?: number;
    aboneNo?: number;

    constructor(
        yapilandirmaTuru?: string,
        sicilKodu?: number,
        aboneNo?: number
    ) {
        this.yapilandirmaTuru = yapilandirmaTuru;
        this.sicilKodu = sicilKodu;
        this.aboneNo = aboneNo;
    }
}
export { OrtBakiyeListEbelediyeRequest };